// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2276":"9c726354f39cc273","3764":"d4430a3c045ec090"}[chunkId] + ".js";
};